"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeArrayFromLength = void 0;
var makeArrayFromLength = function (len) {
    if (typeof len !== 'number' || len < 0 || !Number.isInteger(len)) {
        return Array.from(Array(0).keys());
    }
    return Array.from(Array(len).keys());
};
exports.makeArrayFromLength = makeArrayFromLength;
